/**
 * Browser tab title convention: "{page} | Evib Group".
 * The tab icon itself is the Evib favicon wired in public/index.html.
 */
import { useEffect } from 'react';

const usePageTitle = (page) => {
    useEffect(() => {
        if (page) {
            document.title = `${page} | Evib Group`;
        }
    }, [page]);
};

export default usePageTitle;
